import * as types from '../event_types'
import * as restlet from '../actions/rest'
import * as admin from '../actions/admin'
import Vue from 'vue';


// STATE

const state = {
  showNotification: false,
  notificationMessage: "",
  series: [],
  inbox: [],
  seriesFilter: null,
  inboxFilter: null,
  serie: undefined,
  message: undefined
}

// GETTERS

const getters = {
  showNotification: s => s.showNotification,
  notificationMessage: s => s.notificationMessage,
  filteredSeries: function (s) {
    if (s.seriesFilter && s.seriesFilter.length > 2) {
      return { 'filtered': true, 'results': s.series.filter(serie => serie.title.toLowerCase().indexOf(s.seriesFilter.toLowerCase()) != -1) }
    } else {
      return { 'filtered': false, 'results': s.series }
    }
  },
  filteredInbox: function (s) {
    if (s.inboxFilter && s.inboxFilter.length > 2) {
      return s.inbox.filter(notification => notification.message.title.toLowerCase().indexOf(s.inboxFilter.toLowerCase()) != -1)
    } else {
      return s.inbox
    }
  },
  serie: s => s.serie,
  message: s => s.message
}

// ACTIONS

const actions = {
  notify({ commit }, message) {
    commit(types.SET_MESSAGE_TEXT, message)
    commit(types.SHOW_NOTIFICATION, true)
  },
  getSeriesForAdmin({ commit }) {
    admin.getSeries().then(function (response) {
      if (response.status == 200) {
        commit(types.SET_SERIES, response.data.data.series)
      }
    })
  },
  getSerieById({ commit }, id) {
    admin.getSeriesBySeriesId(id).then(function (response) {
      if (response.status == 200) {
        commit(types.SET_SERIE, response.data.data)
      }
    })
  },
  setSeriesFilter({ commit }, f) {
    commit(types.SET_SERIES_FILTER, f)
  },
  createSeries({ commit }, title) {
    admin.createSeriesByTitle(title).then(function (response) {
      if (response.status == 200) {
        commit(types.ADD_SERIES, response.data.data)
      }
    })
  },
  createMessageTemplate({ commit }, { series_id, template}) {
    admin.createTemplateForSeries(series_id, template).then(function (response) {
      if (response.status == 200) {
        commit(types.ADD_SERIES_MESSAGE_TEMPLATE, response.data.data)
      }
    })
  },
  createAssignment({ commit }, { series_id, assignment }) {
    admin.createAssignmentForSeries(series_id, assignment).then(function (response) {
      if (response.status == 200) {
        commit(types.ADD_SERIES_ASSIGNMENT, response.data.data)
      }
    })
  },
  getMyInbox({ commit }) {
    restlet.getMyInbox().then(function (response) {
      if (response.status == 200) {
        commit(types.SET_INBOX, response.data.data.messages)
      }
    })
  },
  getMessageById({ commit }, id) {
    restlet.getMessageById(id).then(function(response) {
      if(response.status == 200) {
        commit(types.SET_MESSAGE, response.data.data)
      }
    })
  }
}

// MUTATIONS

/* eslint no-param-reassign:
["error", { "props": false}] */

const mutations = {
  setMessageText(s, message) {
    Vue.set(s, 'notificationMessage', message)
  },
  showNotification(s, notify) {
    Vue.set(s, 'showNotification', notify)
  },
  setSeries(s, series) {
    Vue.set(s, 'series', series)
  },
  setSerie(s, serie) {
    Vue.set(s, 'serie', serie)
  },
  setSeriesFilter(s, f) {
    Vue.set(s, 'seriesFilter', f)
  },
  addSeries(s, f) {
    Vue.set(s, 'series', s.series.concat([f]))
  },
  addSeriesMessageTemplate(s, m) {
    if (s.serie) {
      let serie = s.serie
      serie.templates= serie.templates.concat(m)
      Vue.set(s, 'serie', serie)
    }
  },
  addSeriesAssignment(s, m) {
    if (s.serie) {
      let serie = s.serie
      serie.assignments = serie.assignments.concat(m)
      Vue.set(s, 'serie', serie)
    }
  },
  setInbox(s, m) {
    Vue.set(s, 'inbox', m)
  },
  setMessage(s, m) {
    Vue.set(s, 'message', m)
  }

}

// EXPORT

export default {
  state,
  getters,
  actions,
  mutations
}
